import React, { useState, useEffect } from 'react';

const projects = [
  {
    title: "MedLinker",
    description: "MedLinker is a web application that focuses on enhancing the interface between patients and healthcare providers. Its multifaceted functionalities streamline the process of connecting patients with doctors, ensuring a seamless healthcare experience.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSA9GO2Q3uNbrAicw6gAO330-lexRVesuwLQHzvRYmTO9oxOB24Kwn7F8o_n38a6pA-_6U&usqp=CAU",
    link: "https://github.com/0mahendra/MedLinker",
  },
  {
    title: "Delight",
    description: "Delight is a personality development app with a chatting app, a to-do list for daily tasks, a meditation page, an audio page to store and listen to audio files, and a contact us page for any complaints.",
    image: "https://blog.solguruz.com/wp-content/uploads/2023/11/How-to-develop-a-Meditation-App-like-Calm-and-Headspace.png",
    link: "https://github.com/0mahendra/Delight",
  },
  {
    title: "Snippeter",
    description: "Snippeter is a web-based application aimed at helping developers create and use snippets across platforms. An AI assistant helps new coders generate snippets for algorithms.",
    image: "https://media.dev.to/cdn-cgi/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fkjggdpr4b0mowtytta3p.png",
    link: "https://github.com/itsManish01/Snippeter",
  },
  {
    title: "Loan-App",
    description: "SwiftLoan is a streamlined loan application platform. The app ensures efficient loan processing with real-time updates on application status and payment verification.",
    image: "https://img.freepik.com/free-photo/house-loan-estate-sell-mortgage-concept_53876-127702.jpg?t=st=1731219211~exp=1731222811~hmac=9595010713bb6e4a9a55630f4813de2adf33e75b4fa466e023412a628e0b3a0d&w=996",
    link: "https://github.com/0mahendra/SwiftLoan",
  },
];

const ProjectSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length);
    }, 3000); // Switch card every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen text-white p-8">
      <div className="relative w-3/4 max-w-lg rounded-lg shadow-lg bg-white text-gray-800 overflow-hidden transition-transform duration-500 transform hover:scale-105">
        <div className="text-center p-4 bg-indigo-600 text-white text-2xl font-bold">
          My Projects
        </div>
        <div className="p-4 text-center">
          <img
            src={projects[currentIndex].image}
            alt={projects[currentIndex].title}
            className="w-full h-48 object-cover rounded-t-lg"
          />
          <h2 className="mt-4 text-xl font-semibold text-gray-800">
            {projects[currentIndex].title}
          </h2>
          <p className="mt-2 text-gray-600">{projects[currentIndex].description}</p>
          <a
            href={projects[currentIndex].link}
            className="inline-block mt-4 text-indigo-500 hover:text-indigo-700 font-semibold"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn More
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProjectSlider;
